import React from 'react';
import { ExternalLink } from 'lucide-react';
import { useSiteSettings } from '../context/SiteSettingsContext';

const AnnouncementBar = () => {
  const { settings } = useSiteSettings();
  if (!settings?.announcement_enabled || !settings?.announcement_text) return null;
  const link = settings.announcement_link;
  const inner = (
    <div className="flex items-center justify-center gap-2 text-center">
      <span className="font-medium text-sm">{settings.announcement_text}</span>
      {link && <ExternalLink className="w-3.5 h-3.5" />}
    </div>
  );
  return (
    <div className="bg-[#c8102e] text-white py-2.5 px-6">
      {link ? (
        <a href={link} target={link.startsWith('http') ? '_blank' : undefined} rel="noreferrer" className="hover:underline">{inner}</a>
      ) : inner}
    </div>
  );
};

export default AnnouncementBar;
